export const FETCH_ADD_AD_TECHNOLOGIES_REQ = "FETCH_ADD_AD_TECHNOLOGIES_REQ";
export const FETCH_ADD_AD_TECHNOLOGIES_ERR = "FETCH_ADD_AD_TECHNOLOGIES_ERR";
export const FETCH_ADD_AD_TECHNOLOGIES_SUCCESS = "FETCH_ADD_AD_TECHNOLOGIES_SUCCESS";

export const CHANGE_ISCHECKED_VALUE_ADD_AD = "CHANGE_ISCHECKED_VALUE";

export const RESET_ISCHECKED_VALUE_ADD_AD = "RESET_ISCHECKED_VALUE_ADD_AD";
